var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1668 27.5758C54.1668 41.5841 39.8532 53.9659 34.4939 58.1109C33.3109 59.0259 31.6894 59.0259 30.5064 58.1109C25.1471 53.9659 10.8335 41.5841 10.8335 27.5758C10.8335 21.6989 13.1162 16.0626 17.1795 11.907C21.2428 7.75136 26.7538 5.41675 32.5002 5.41675C38.2465 5.41675 43.7575 7.75136 47.8208 11.907C51.8841 16.0626 54.1668 21.6989 54.1668 27.5758Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 35.2085C36.9873 35.2085 40.625 31.5708 40.625 27.0835C40.625 22.5962 36.9873 18.9585 32.5 18.9585C28.0127 18.9585 24.375 22.5962 24.375 27.0835C24.375 31.5708 28.0127 35.2085 32.5 35.2085Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.81c283a6e5abc27ca898bdd4e5e49bb2.svg";
export { ForwardRef as ReactComponent };